import {
	Box,
	Button,
	Grow,
	MenuItem,
	MenuList,
	Popper,
	TextField,
} from "@material-ui/core";
import { Add, AddRounded, CodeRounded } from "@material-ui/icons";
import React, { useRef, useState } from "react";
import color from "../../constants/Color";
import {
	variableTemplate,
	VariableTemplate,
} from "../../model/setup-sequelize/EVariableTemplate";

type Props = {
	onClick : (value: string)=> void,
	variables : string[]

}
export default function InsertVariable(props: Props) {
	const [anchorRefEl, setAnchorRefEl] = useState<HTMLButtonElement | null>();
	const handleClickInsert = (e: React.MouseEvent<HTMLElement>) => {
		setAnchorRefEl(anchorRefEl ? null : (e.currentTarget as any));
	};
	const open = Boolean(anchorRefEl);

	return (
		<Box>
			<Button
				aria-haspopup="true"
				variant="outlined"
				color={"primary"}
				startIcon={<CodeRounded />}
				onClick={handleClickInsert}
			>
				Insert variable
			</Button>
			<Popper open={open} anchorEl={anchorRefEl} transition disablePortal>
				{({ TransitionProps, placement }) => (
					<Grow
						{...TransitionProps}
						style={{
							transformOrigin: "center bottom",
						}}
						timeout={200}
					>
						<MenuList>
							{props.variables.map((item) => (
								<MenuItem
									style = {{
										background : color.primary
									}}
									onClick= {(e)=>{
										props.onClick(item)
									}}
								>{item}</MenuItem>
							))}
						</MenuList>
					</Grow>
				)}
			</Popper>
		</Box>
	);
}
